import axios from 'axios'
import isEmpty from 'lodash-es/isEmpty'
import GetCookie from '../globalHeader/common/getCookie'
import { tokenCookieKey } from '../globalHeader/functions/ams-functions'
import { getRuntimeEnv } from '../utils/runtimeEnv'

export const getWalletApiUrl = (): string => {
    const runtimeUrl = getRuntimeEnv('VITE_REACT_APP_WALLET_URL')
    if (runtimeUrl) return runtimeUrl
    // ts-ignore needed for next.js app
    // @ts-ignore
    if (!isEmpty(import.meta) && import.meta.env.VITE_REACT_APP_WALLET_URL) {
        // @ts-ignore
        return import.meta.env.VITE_REACT_APP_WALLET_URL
    } else if (process.env.NEXT_PUBLIC_WALLET_URL) {
        return process.env.NEXT_PUBLIC_WALLET_URL
    } else {
        throw new Error('API URL is not defined')
    }
}

export const walletAPI = axios.create({
    baseURL: getWalletApiUrl(),
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})

// Add a request interceptor
walletAPI.interceptors.request.use(
    async (config) => {
        // Bearer as well as the cookie: WebViews and cookie-blocking browsers may not deliver the jwt cookie here
        const token = GetCookie(tokenCookieKey)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// Add a response interceptor
walletAPI.interceptors.response.use(
    (response) => response,
    async (error) => {
        // A 401 goes back to the caller untouched: renewToken() deletes the jwt cookie when it fails,
        // so calling it from here would turn a wallet 401 into a lost session
        return Promise.reject(error)
    },
)
